
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/musical-entertainment",
      function () {
        return require("private-next-pages/musical-entertainment/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/musical-entertainment"])
      });
    }
  